import React, { Component } from "react";
import Button from "../Button";
import Wrapper from "../../../_hoc/Wrapper";

export default class EditWidget extends Component {
  render() {
    const {
      edit,
      onEdit,
      onSave,
      onCancel,
      disabled,
      saving,
      show
    } = this.props;

    if (!show) {
      return null;
    }
    //disabled
    if (disabled) {
      return (
        <Button
          label="Edit"
          style={{ float: "right" }}
          info
          small
          clean
          rounded
          onClick={onEdit}
          disabled
        />
      );
    }

    if (!edit) {
      return (
        <Wrapper>
          <Button
            label="Edit"
            style={{ float: "right" }}
            info
            small
            clean
            rounded
            onClick={onEdit}
          />
        </Wrapper>
      );
    } else {
      return (
        <Wrapper>
          <Button
            label="Cancel"
            style={{ float: "right" }}
            default
            small
            clean
            rounded
            onClick={onCancel}
          />
          <Button
            label="Save"
            style={{ float: "right", marginRight: "10px" }}
            primary
            small
            clean
            rounded
            onClick={onSave}
          />
        </Wrapper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/EditWidget/index.js